export default "__VITE_ASSET__B3P8NCrl__"